import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';

import { IntlMsg } from '../../components/_core/IntlMsg/intl-msg.component';
import { messages } from '../../components/_core/OfflineHandler/offline-handler.messages';
import { subscribeClientUpdateRequired } from '../utils/client-update.link';

export interface IClientUpdateSnackbarDeps {
  reload: () => void;
}

const defaultDeps = (): IClientUpdateSnackbarDeps => ({ reload: () => window.location.reload() });

// Prompts the scorer to reload once the server has refused this bundle for being unable to report
// every action. Persistent and not dismissible: nothing syncs again on this page load.
export const useClientUpdateSnackbar = (deps: IClientUpdateSnackbarDeps = defaultDeps()) => {
  const { enqueueSnackbar } = useSnackbar();
  const { reload } = deps;

  useEffect(() => subscribeClientUpdateRequired(() => {
    enqueueSnackbar(
      <IntlMsg {...messages.clientUpdateRequired} />,
      {
        variant: 'error',
        persist: true,
        key: 'client-update-required',
        preventDuplicate: true,
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        action: () => (
          <Button size="small" color="inherit" onClick={reload}>
            <IntlMsg {...messages.clientUpdateReload} />
          </Button>
        ),
      },
    );
  }), [enqueueSnackbar, reload]);
};
